/**
 * Afyanex brand assets — clean inline SVG mark + horizontal lockup.
 * Two overlapping rounded "play" / forward-arrow rectangles in a cyan→blue gradient.
 * No external image dependency. Scales perfectly.
 */
import React from "react";

/**
 * Square mark (the icon only).
 * @param {{ size?: number, className?: string }} props
 */
export function AfyanexMark({ size = 32, className = "" }) {
  const id = React.useId();
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      role="img"
      aria-label="Afyanex"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={`afn-${id}-a`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00B3FF" />
          <stop offset="100%" stopColor="#005EFF" />
        </linearGradient>
        <linearGradient id={`afn-${id}-b`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#0072FF" />
          <stop offset="100%" stopColor="#004AE6" />
        </linearGradient>
      </defs>
      {/* Back rounded rect, rotated slightly */}
      <g transform="translate(50 50) rotate(-22) translate(-50 -50)">
        <rect
          x="14"
          y="36"
          width="72"
          height="28"
          rx="14"
          fill={`url(#afn-${id}-b)`}
          opacity="0.85"
        />
      </g>
      {/* Front rounded rect */}
      <g transform="translate(50 50) rotate(22) translate(-50 -50)">
        <rect
          x="14"
          y="36"
          width="72"
          height="28"
          rx="14"
          fill={`url(#afn-${id}-a)`}
        />
      </g>
    </svg>
  );
}

/**
 * Full horizontal lockup: mark + "afyanex" wordmark with pink "nex" suffix.
 */
export function AfyanexLogo({ markSize = 28, className = "", showTagline = false }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <AfyanexMark size={markSize} />
      <span className="leading-none">
        <span className="afyanex-wordmark text-[1.15em]">
          afya<span className="nex">nex</span>
        </span>
        {showTagline && (
          <span className="block mt-0.5 text-[10px] tracking-[0.18em] uppercase text-clinical-subtext">
            Care Documentation
          </span>
        )}
      </span>
    </span>
  );
}

export default AfyanexLogo;
